import { compose, identity, path, merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';

export default class EditUserForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    return (
      <form>
        {this.renderInput('Nombre', 'name')}
        {this.renderInput('Compañía', 'company')}
        {this.renderInput('Edad', 'age')}
        {this.renderRow('Sexo', this.renderSexRadioButton())}
      </form>
    );
  }
  renderInput(label, id) {
    const value = this.props.value[id] ? this.props.value[id] : undefined;
    const input = <input type='text' defaultValue={value} onChange={this.handleChange(id, path(['target', 'value']))} />;
    return this.renderRow(label, input);
  }
  renderRow(label, input) {
    return (
      <div className='row form-group'>
        <label className='col-xs-3 col-xs-offset-2' style={{ textAlign: 'right' }}>{label}</label>
        <div className='col-xs-6'>
          {input}
        </div>
      </div>
    );
  }
  renderSexRadioButton() {
    return (
      <div>
        <div>
          <input type='radio' name='sex' value='Masculino' checked={this.props.value.sex === 'M'} onChange={() => this.props.onChange(R.merge(this.props.value, { sex: 'M' }))} /> Masculino
        </div>
        <div>
          <input type='radio' name='sex' value='Femenino' checked={this.props.value.sex === 'F'} onChange={() => { this.props.onChange(R.merge(this.props.value, { sex: 'F' })) }} /> Femenino
        </div>
      </div>
    );
  }
  handleChange(field, getValue) {
    return (event) => {
      const value = getValue(event);
      this.props.onChange(merge(this.props.value, { [field]: value }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/users/EditUserForm.jsx